import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../shared/services/alert.service';
import { Observable } from 'rxjs';
import { SettingService } from '../shared/services/setting.service';
import { finalize } from 'rxjs/operators';
import { ApiControllerService } from '../shared/services/api-controller.service';

export interface ILocation {
  Id?: number;
  DisplayName?: string;
  Inactive?: boolean;
  HasActiveTerminals?: boolean;
  Latitude?: number;
  Longitude?: number;
  FormattedAddress?: string;
  Phone?: string;
  PhoneExtension?: string;
  Hours: IHours[];
  ImageUrl?: string;

  __distanceInKM?: number;
  __currentDayHours: IHours;
}

export interface IHours {
  Days: number;
  OpenTime: string;
  CloseTime: string
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {


  constructor(private http: HttpClient,
              private setting: SettingService,
              private apiController: ApiControllerService) { }

  locations(): Observable<ILocation[]> {
    return Observable.create(o => {
      /* let o$ = this.http.get(this.setting.getLegacySmaUrl('V2/Page/LocationsWithHours'), {
        params: { 
          pageId: this.setting.smaPageId 
        }
      }); */

      let o$ = this.apiController.get(this.setting.getLegacySmaUrl('V2/Page/LocationsWithHours'), {
        params: { 
          pageId: this.setting.smaPageId 
        }
      });

      o$
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          locations => {
            o.next(locations);
          },
          res => o.error(res)
        );
    });
  }
}
